import { type ReactElement, useId } from 'react';
import { Input, Label } from '@/shared/ui';
import { normalizeDeg } from '../model/handles';

interface RotationFieldProps {
  readonly value: number;
  readonly onChange: (rotationDeg: number) => void;
  readonly className?: string;
}

/** 회전(°) 입력 — -180~180 으로 감아 알린다. 캔버스의 회전 핸들과 같은 값이다. */
export const RotationField = ({ value, onChange, className }: RotationFieldProps): ReactElement => {
  const id = useId();
  return (
    <div className={className}>
      <Label htmlFor={id} className="text-xs">
        회전(°)
      </Label>
      <Input
        id={id}
        type="number"
        className="mt-1.5 px-3"
        step={1}
        value={Math.round(value)}
        onChange={(event) => {
          const parsed = Number(event.target.value);
          if (event.target.value !== '' && Number.isFinite(parsed)) onChange(normalizeDeg(parsed));
        }}
      />
    </div>
  );
};
